import Images from '../Utils/images';

interface Props {
  isLoading?: boolean;
}
/**
 * Displays a loading notification based on the loading state.
 * @example
 * LoadingNotification({ isLoading: true });
 * // Renders a loading spinner with styles indicating loading state.
 * @param {Object} props - The Props object containing attributes.
 * @param {boolean} props.isLoading - Indicates whether loading is in progress.
 * @returns {JSX.Element} The JSX markup for loading notification display.
 * @description
 *   - Applies specific CSS classes to show loading state visually.
 *   - Adjusts styling and content dynamically based on loading state.
 *   - Displays a spinner when loading is active.
 *   - The notification message appears only when loading is inactive.
 */
export default function LoadingNotification(props: Props) {
  const { isLoading } = props;
  return (
    <div
      className={`success no_notification ${isLoading ? 'isLoading' : null}`}
    >
      <img
        src={Images.LOADER_TWO}
        alt={'Loading, Please wait'}
        style={{
          width: '60px',
          margin: isLoading ? 0 : '40px 0',
        }}
      />
      {isLoading ? null : <h3>Loading, Please wait</h3>}
    </div>
  );
}
